import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

const sizes = {
  h1: 'text-4xl',
  h2: 'text-3xl',
  h3: 'text-2xl',
  h4: 'text-xl',
  h5: 'text-lg',
  p: 'text-base',
  span: 'text-sm',
  label: 'text-xs',
};

const weights = {
  light: 'font-light',
  normal: 'font-normal',
  medium: 'font-medium',
  bold: 'font-bold',
};

const colors = {
  primary: 'text-[#384250] dark:text-[#E5E7EB]',
  secondary: 'text-[#6C737F] dark:text-[#E5E7EB]',
  accent: 'text-[#7846FF]',
};

type TypographyProps = React.ComponentProps<'div'> & {
  size?: keyof typeof sizes;
  weight?: keyof typeof weights;
  color?: keyof typeof colors;
  children: ReactNode;
  className?: string;
};

export default function Typography({
  size = 'p',
  weight = 'normal',
  color = 'primary',
  className,
  children,
  ...props
}: TypographyProps) {
  return (
    <div
      className={cn(sizes[size], weights[weight], colors[color], className)}
      {...props}
    >
      {children}
    </div>
  );
}
